import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { HttpClient } from '@angular/common/http';
import { coerceNumberProperty } from '@angular/cdk/coercion';
import { HttpHeaders, HttpEventType, HttpRequest, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { User } from '../User';
import { AlertService } from '../alert.service';
import { ModalDirective } from 'angular-bootstrap-md';
import { Item, ITEMS } from '../rating-data';
@Component({
  selector: 'app-completed-booking',
  templateUrl: './completed-booking.component.html',
  styleUrls: ['./completed-booking.component.scss']
})

export class CompletedBookingComponent implements OnInit {
  @ViewChild('RatingModal') RatingModal: ModalDirective;
  private user: User = new User();
  public showMsg;

  date: string = "";

  btnTextShow: string = 'View More';
  btnTextHide: string = 'View Less';

  custData: Observable<any>;
  show: boolean = false;
  tCollapse(): void {
    this.show = !this.show;
  }
  public getCompDetail: any = [];
  private debugData: Boolean = true; // to show and hide the data in console log
  btnText: string = this.btnTextShow;
  deliveryType = 0;
  radioSel: any;
  radioSelected: string;
  radioSelectedString: string;
  itemsList: Item[] = ITEMS;
  selectedIndex: number;
  select(index: number) {
      this.selectedIndex = index;
  }
  constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService, private apiService: ApiService,
    private httpClient: HttpClient, private alertService: AlertService) {
    this.itemsList = ITEMS;
    this.radioSelected = "Okay";
    this.getSelecteditem();

  }
  getSelecteditem() {
    this.radioSel = ITEMS.find(Item => Item.value === this.radioSelected);
    this.radioSelectedString = JSON.stringify(this.radioSel);
    //console.log(this.radioSel.id);
  }

  onItemChange(item) {
    this.getSelecteditem();

  }
  rateId(idValue) {
  this.bookId = idValue;
    console.log(this.bookId)
  }
  public getCompRateDataDetail: any = [];
  bookId: number;
  ratingErrMsg: string = ""; //show rating error message
  submitUserRating(comment) {
    let getRateData = { 'rating': this.radioSel.id, 'comments': comment, 'booking': this.bookId };
    console.log(getRateData);
    this.httpClient.post(this.apiService.userRating, getRateData)
      .subscribe(
        (rate_detail: any) => {
          if (this.debugData) {
            console.log("user rating data")
            console.log(rate_detail)
          }
          this.getCompRateDataDetail = rate_detail;
          this.initCustData();
          console.log(this.getCompRateDataDetail);
        },
        (err) => {
          this.ratingErrMsg = "Some error occured. Please try again";
        });

  }
  ngOnInit() {
    this.initCustData();
  }
  initCustData() {
    if (this.apiService.checkUserLoggedIn() == true) {
      let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
      this.httpClient.get(urrr)
        .subscribe(
          data => this.intilizeComponent(data),
          error => this.showError(error)
        );

    } else {
      console.log("User Not Logged In. Please login!")
    }

  }

  intilizeComponent(data) {
    this.user = data;
    this.getBookingCompleted();
  }

  showError(msg) {
    console.log("Error Found in server");
  }

  toggleCollapse(): void {
    if (this.btnText === this.btnTextShow) {
      this.btnText = this.btnTextHide;
    }
    else {
      this.btnText = this.btnTextShow;
    }
  }


  isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
  }


  getBookingCompleted() {
    let getDATA = { "Customer": this.user.id, "status": 2 }
    this.httpClient.post(this.apiService.getBookingBYquery, getDATA)
      .subscribe(
        (data_detail: any) => {
          console.log(data_detail);
          this.getCompDetail = data_detail;

        }
      )
  }



}




// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/completed-booking/completed-booking.component.ts